<template>
    <AppLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
            <IndexStats :stats="stats"></IndexStats>
            <JobIndex :jobs="jobs" :search="search"></JobIndex>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import IndexStats from "./IndexStats";
    import JobIndex from "@/Jobroll/JobIndex";

    export default {
        name: 'Index',
        metaInfo: {title: 'Dashboard'},
        components: {
            AppLayout,
            IndexStats,
            JobIndex
        },
        props: {
            message: String,
            jobs: Object,
            stats: Array,
            search: String
        }
    }
</script>
